'use strict';

module.exports = {
  GET_DIGITAL_GIFTS: 'get-digital-gifts',
  GET_DIGITAL_GIFT_CARD: 'get-digital-gift-card',
};
